import { render, staticRenderFns } from "./UserPointRecord.vue?vue&type=template&id=14655a62"
import script from "./UserPointRecord.vue?vue&type=script&lang=js"
export * from "./UserPointRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports